import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import AuthContext from "../../../../context/AuthContext";
import useLoginAPI from "../../../../api/useLogin";
import { Toast } from "primereact/toast";
import "./Register.css";
import { useDispatch } from "react-redux";
import {
  goToLogin,
  hideDialog,
  setShowLoginDialog,
  setShowRegister,
} from "../../../../redux/dialogSlice";
import { logInUserFunc } from "../../../../redux/userState";
import { Dropdown } from "primereact/dropdown";
import { AccountType } from "../../Login_Page/AccountTypeModal";
interface RegisterProps {
  accountType: AccountType;
  onBackToLogin?: () => void;
  onRegisterSuccess?: () => void;
}
const Register: React.FC<RegisterProps> = ({
  accountType,
  onBackToLogin,
  onRegisterSuccess,
}) => {
  const basePath = process.env.REACT_APP_BASE_PATH;

  const {
    sendOTP,
    verifyOTP,
    saveUserAPI,
    saveCustomerAPI,
    generateToken,
    getCompanyNames,
    getDepartmentNames,
  } = useLoginAPI();

  const toast = useRef<Toast>(null);
  const dispatch = useDispatch();

  const { loginUser } = useContext(AuthContext) || {};
  const [username, setUsername] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [userFullNameError, setUserFullNameError] = useState("");
  const [OTP, setOTP] = useState("");
  const [emailError, setEmailError] = useState("");
  const [checkbox, setCheckbox] = useState(false); // or false if you want unchecked by default
  const [OTPError, setOTPError] = useState("");
  const [displayOTP, setDisplayOTP] = useState("");
  const [sendingOTP, setSendingOTP] = useState(false);
  const navigate = useNavigate();
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(30);
  let [authTokens, setAuthTokens] = useState(() => {
    const storedTokens = localStorage.getItem("authTokens");
    if (storedTokens === "undefined") {
      localStorage.clear();
      navigate(`${basePath}`);
    }
    return storedTokens ? JSON.parse(storedTokens) : null;
  });

  const [companyListOptions, setCompanyListOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [isSelectingCompany, setIsSelectingCompany] = useState(false);
  const [departmentListOptions, setDepartmentListOptions] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [isSelectingDepartment, setIsSelectingDepartment] = useState(false);
  const [registrationError, setRegistrationError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  const resendOTP = (e: any) => {
    setIsResendDisabled(true);
    setOTP("");
    setDisplayOTP("");
    setRegistrationError("");
    sendOTPFunc(e);
  };

  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateFullName = (fullName: string) => {
    const re = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
    return re.test(fullName);
  };

  const sendOTPFunc = async (e?: any) => {
    e.preventDefault();
    if (!checkbox) {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Accept the Terms & Condition",
      });
      return;
    }
    setOTP("");
    setDisplayOTP("");
    setRegistrationError("");
    setIsSelectingCompany(false);
    setIsSelectingDepartment(false);
    if (!validateEmail(username) || userFullName === "") {
      if (!validateEmail(username)) {
        setEmailError("Invalid email");
      }

      if (userFullName === "") {
        setUserFullNameError("Please enter full name");
      }

      if (!validatePhoneNumber(phoneNumber)) {
        setPhoneNumberError("Invalid phone number");
      }

      return toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `Please enter valid email`,
      });
    }

    const payload = {
      username: accountType === "corporate" ? username : phoneNumber,
      phone: accountType === "corporate" ? undefined : phoneNumber,
      roles:
        accountType === "corporate"
          ? ["ROLE_CORPORATE_USER"]
          : ["ROLE_CUSTOMER"],
      is_for_login: false,
    };
    const response: any = await sendOTP(payload);
    if (response?.response?.status === 400) {
      // setDisplayOTP(response.otp);
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    } else if (response?.response?.status === 404) {
      // setDisplayOTP(response.otp);
      setSendingOTP(false);
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    } else if (response.status === 200) {
      setSendingOTP(true);
      setDisplayOTP(response?.data?.otp);
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `${response?.data?.message}`,
      });
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `Failed to sent OTP`,
      });
    }
  };

  const verifyOTPFunc = async (e: any) => {
    e.preventDefault();
    if (!checkbox) {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Accept the Terms & Condition",
      });
      return;
    }
    if (OTP === "") {
      setOTPError("Please Enter OTP");
    }
    const payload = {
      // username: username,
      username: accountType === "corporate" ? username : phoneNumber,
      otp: OTP,
    };
    const response: any = await verifyOTP(payload);

    if (response.status === 200) {
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `${response?.data?.message}`,
      });

      // const saveUserPayload = {
      //   email: username,
      //   username: username,
      //   phone: phoneNumber,
      //   roles:
      //     accountType === "corporate"
      //       ? ["ROLE_CORPORATE_USER"]
      //       : ["ROLE_CUSTOMER"],
      //   company_id: selectedCompany.length === 0 ? null : selectedCompany,
      //   department_id:
      //     selectedDepartment.length === 0 ? null : selectedDepartment,
      //   full_name: userFullName === "" ? null : userFullName,
      // };
      // const saveUserResponse: any = await saveUserAPI(saveUserPayload);
      const saveUserPayload = {
        email: username,
        username: accountType === "corporate" ? username : phoneNumber,
        phone: phoneNumber,
        roles:
          accountType === "corporate"
            ? ["ROLE_CORPORATE_USER"]
            : ["ROLE_CUSTOMER"],
        company_id: selectedCompany.length === 0 ? null : selectedCompany,
        department_id:
          selectedDepartment.length === 0 ? null : selectedDepartment,
        full_name: userFullName === "" ? null : userFullName,
      };
      const saveUserResponse: any =
        accountType === "customer"
          ? await saveCustomerAPI(saveUserPayload)
          : await saveUserAPI(saveUserPayload);
      // console.log("Save Response", saveUserResponse);
      // console.log("Save Data", saveUserResponse?.data);
      if (saveUserResponse.status === 200 || saveUserResponse.status === 201) {
        if (
          accountType === "corporate" &&
          saveUserResponse?.data?.registration_type === "MULTI-COMPANY"
        ) {
          const payload = { domain: username };
          const response = await getCompanyNames(payload);
          if (response.status === 200) {
            setIsSelectingCompany(true);
            setCompanyListOptions(response?.data);
          }
        } else if (
          accountType === "corporate" &&
          saveUserResponse?.data?.registration_type === "MANY-DEPT"
        ) {
          const response = await getDepartmentNames(selectedCompany);
          if (response.status === 200) {
            setIsSelectingDepartment(true);
            setDepartmentListOptions(response?.data);
          }
        } else if (saveUserResponse?.status === 201) {
          // const generateTokenPayload = {
          //   username: username,
          //   login_panel: "WEB",
          //   otp: OTP,
          // };
          const generateTokenPayload = {
            username: accountType === "corporate" ? username : phoneNumber,
            login_panel: "WEB",
            otp: OTP,
          };
          const generateTokenResponse: any =
            await generateToken(generateTokenPayload);

          if (
            generateTokenResponse.status === 200 ||
            generateTokenResponse.status === 201
          ) {
            setAuthTokens(generateTokenResponse?.data?.tokens);
            localStorage.setItem(
              "authTokens",
              JSON.stringify(generateTokenResponse?.data?.tokens),
            );
            dispatch(hideDialog());
            dispatch(logInUserFunc());
            dispatch(setShowLoginDialog(false));
            onRegisterSuccess?.();
            toast?.current?.show({
              severity: "success",
              summary: "Success",
              detail: `${generateTokenResponse?.data?.message}`,
            });
          } else {
            toast?.current?.show({
              severity: "error",
              summary: "Failed",
              detail: `${generateTokenResponse?.response?.data?.error}`,
            });
          }
        }
      } else if (saveUserResponse?.response?.status === 400) {
        const generateTokenPayload = {
          username: accountType === "corporate" ? username : phoneNumber,
          login_panel: "WEB",
          otp: OTP,
        };
        const generateTokenResponse: any =
          await generateToken(generateTokenPayload);

        if (
          generateTokenResponse.status === 200 ||
          generateTokenResponse.status === 201
        ) {
          setAuthTokens(generateTokenResponse?.data?.tokens);
          localStorage.setItem(
            "authTokens",
            JSON.stringify(generateTokenResponse?.data?.tokens),
          );
          dispatch(hideDialog());
          dispatch(logInUserFunc());
          dispatch(setShowLoginDialog(false));
          onRegisterSuccess?.();
          toast?.current?.show({
            severity: "success",
            summary: "Success",
            detail: `${generateTokenResponse?.data?.message}`,
          });
        } else {
          setRegistrationError(
            "This email or phone is already registered under a different account type. Please try logging in instead.",
          );
          toast?.current?.show({
            severity: "error",
            summary: "Registration Failed",
            detail:
              "This account already exists under a different type. Try logging in instead.",
          });
        }
      } else {
        toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `${saveUserResponse?.response?.data?.error}`,
        });
      }
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.message}`,
      });
    }
  };
  const onInputChang = (e: any) => {
    setEmailError("");
    setUsername(e.target.value);
  };

  const validatePhoneNumber = (number: string) => {
    const re = /^\d{10}$/;
    return re.test(number);
  };

  const onPhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhoneNumberError("");
    const newPhoneNumber = e.target.value;
    if (/^\d+$/.test(newPhoneNumber)) {
      setPhoneNumber(newPhoneNumber);
    }
  };

  const onFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserFullNameError("");
    const fullNameRegex = /^[a-zA-Z.,_'"" ]*$/;
    const fullName = e.target.value;
    if (fullNameRegex.test(fullName)) {
      setUserFullName(fullName);
    }
  };

  const handleOTPInput = (e: any) => {
    setOTPError("");
    const inputOTP = e.target.value;
    const regex = /^[0-9]*$/;
    if (regex.test(inputOTP)) {
      setOTP(inputOTP);
    }
  };

  const handleLogin = () => {
    dispatch(setShowRegister(false));
    onBackToLogin?.();
  };

  const handleCompanyChange = async (e: any) => {
    setIsSelectingDepartment(true);
    setSelectedDepartment([]);
    const response = await getDepartmentNames(e.target.value);
    if (response.status === 200) {
      setIsSelectingDepartment(true);
      setDepartmentListOptions(response?.data);
    }
    setSelectedCompany(e.target.value);
  };
  const handleDepartmentChange = (e: any) => {
    setSelectedDepartment(e.target.value);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isResendDisabled && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (!countdown) {
      setIsResendDisabled(false);
      setCountdown(30);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isResendDisabled, countdown]);
  return (
    <div>
      <Toast ref={toast} />
      <div className="registration-form-wrapper">
        <div className="registration-wrapper">
          <div className="register-title">
            {accountType === "corporate"
              ? "Corporate User Register"
              : "Customer Register"}
          </div>{" "}
          <p className="register-subtitle">
            Enter your details to access your account
          </p>
        </div>
        <form>
          <div>
            <div className="field-wrapper">
              <label className="field-label">Full Name</label>
              <InputText
                id="fullname"
                value={userFullName}
                onChange={(e) => onFullNameChange(e)}
                placeholder="Enter your full name"
                className="fullname-input w-full"
              />
              {userFullNameError && (
                <small style={{ color: "red" }}>{userFullNameError}</small>
              )}
            </div>

            <div className="field-wrapper">
              <label className="field-label">Email</label>
              <div className="inline-field-row">
                <InputText
                  id="email1"
                  value={username}
                  onChange={(e) => onInputChang(e)}
                  placeholder="you@example.com"
                  className="email-input"
                />
              </div>
              {emailError && (
                <small style={{ color: "red" }}>{emailError}</small>
              )}
            </div>
            <div className="field-wrapper">
              <label className="field-label">Phone Number</label>
              <div className="inline-field-row">
                <InputText
                  id="phoneNumber"
                  value={phoneNumber}
                  onChange={(e) => onPhoneNumberChange(e)}
                  placeholder="8790000000"
                  className="phone-input"
                  maxLength={10}
                />
                <Button
                  label="Send OTP"
                  onClick={sendOTPFunc}
                  className="send-otp-btn"
                />
              </div>

              {phoneNumberError && (
                <small style={{ color: "red" }}>{phoneNumberError}</small>
              )}
            </div>
          </div>

          {sendingOTP && (
            <div className="otp-wrapper">
              <label className="field-label">OTP</label>
              <InputText
                id="OTP"
                type="OTP"
                value={OTP}
                onChange={(e) => handleOTPInput(e)}
                className="w-full otp-input"
                placeholder="Enter 6-digit OTP"
                maxLength={6}
              />
              {OTPError && <small style={{ color: "red" }}>{OTPError}</small>}
              {registrationError && (
                <small style={{ color: "red" }}>{registrationError}</small>
              )}
              <div className="resend-otp">
                <button
                  disabled={isResendDisabled}
                  onClick={(e: any) => resendOTP(e)}
                  className={isResendDisabled ? "text-disabled" : ""}
                >
                  Resend OTP
                </button>
                {isResendDisabled && <span>({countdown})</span>}
              </div>
              {accountType === "corporate" && (
                <div className="companies-department-options-wrapper">
                  {isSelectingCompany && (
                    <div className="companies-options-wrapper">
                      <label htmlFor="companyDropdown" className="field-label">
                        Please Select A Company
                      </label>

                      <Dropdown
                        id="companyDropdown"
                        value={selectedCompany}
                        onChange={(e) => {
                          handleCompanyChange(e);
                        }}
                        options={companyListOptions}
                        optionLabel="company.organization_name"
                        optionValue="company_id"
                        placeholder="Select a Company"
                        className="w-full company-dropdown"
                      />
                    </div>
                  )}
                  {isSelectingDepartment && (
                    <div className="departments-options-wrapper">
                      <label
                        htmlFor="departmentDropdown"
                        className="field-label"
                      >
                        Please Select A Department
                      </label>
                      <Dropdown
                        id="departmentDropdown"
                        value={selectedDepartment}
                        onChange={(e) => handleDepartmentChange(e)}
                        options={departmentListOptions}
                        optionLabel="department_name"
                        optionValue="company_department_id"
                        placeholder="Select a Department"
                        className="w-full company-dropdown"
                      />
                    </div>
                  )}
                </div>
              )}
              <Button
                label="Continue"
                className="w-full verify-otp-btn"
                onClick={verifyOTPFunc}
                disabled={OTP.length !== 6}
              />
            </div>
          )}
          <div className="by-continuing">
            <input
              type="checkbox"
              className="checkbox"
              checked={checkbox}
              onChange={(e) => setCheckbox(e.target.checked)}
            />{" "}
            <div style={{ marginLeft: "1px" }}>
              I Agree To Mechmiles{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                Terms & Conditions
              </a>{" "}
              And{" "}
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </div>
          </div>
          {/* <div className="by-continuing">
            By Continuing, You Agree To Mechmiles{" "}
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>{" "}
            And{" "}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div> */}
        </form>
      </div>

      <div className="create-account-wrapper">
        <span className="create-account-text">Already Have An Account?</span>
        <a
          onClick={handleLogin}
          className="create-account-text create-account-link cursor-pointer"
        >
          Login
        </a>
      </div>
    </div>
  );
};

export default Register;
